import { SiteLink } from 'interfaces/site-link.interface';

export const items = [
    {
        label: 'Dla użytkownika',
        items: [
            {
                label: 'Skąpiec radzi',
                href: 'https://www.skapiec.pl/radzi',
                title: 'Skąpiec radzi'
            },
            {
                label: 'Zasady sortowania',
                href: '/zasady-sortowania',
                title: 'Zasady sortowania',
                rel: 'nofollow'
            },
            {
                label: 'Najczęściej zadawane pytania',
                href: '/site/doc/4',
                title: 'Najczęściej zadawane pytania',
                rel: 'nofollow'
            },
            {
                label: 'Jak to działa?',
                href: '/site/doc/3',
                title: 'Jak to działa?',
                rel: 'nofollow'
            },
            {
                label: 'Twoje zgody',
                href: 'https://polityka-prywatnosci.onet.pl/',
                title: 'Twoje zgody w serwisie skapiec.pl',
                rel: 'nofollow'
            },
            {
                label: 'Regulamin',
                href: '/regulamin',
                title: 'Regulamin użytkownika',
                rel: 'nofollow'
            },
            {
                label: 'Newsletter',
                href: '/newsletter',
                title: 'Zapisz się na newsletter już dziś!',
                rel: 'nofollow'
            },
            {
                label: 'Zgloś kwestię prawną',
                href: '/report-notice/index.html',
                title: 'Zgloś kwestię prawną',
                rel: 'nofollow',
                icon: 'mail',
                weight: '600',
                target: '_blank'
            }
        ]
    },
    {
        label: 'Dla sklepów',
        items: [
            {
                label: 'Dołącz do Skąpiec.pl',
                href: 'https://panel.onetads.pl',
                title: 'Chcesz zwiększyć sprzedaż?',
                rel: 'nofollow'

            },
            {
                label: 'Raport Sklepów 2023',
                href: 'https://ranking.opineo.pl/?utm_source=stopka&utm_medium=skapiec.pl',
                title: 'Ranking Sklepów Internetowych 2022 - Najlepsze sklepy w Opineo.pl',
                rel: 'nofollow'
            }
        ]
    },
    {
        label: 'Dla partnerów',
        items: [
            {
                label: 'Program Partnerski',
                href: 'https://panel.moneteasy.pl/login',
                title: 'Informacje ogólne',
                rel: 'nofollow'
            },
            {
                label: 'FAQ - Program Partnerski',
                href: 'https://moneteasy.pl/wydawca#faq',
                title: 'Pytania i odpowiedzi',
                rel: 'nofollow'
            },
            {
                label: 'API Skąpiec',
                href: '/site/doc/400',
                title: 'API Skąpiec.pl',
                rel: 'nofollow'
            },
            {
                label: 'Regulamin',
                href: '/regulamin-programu-partnerskiego',
                title: 'REGULAMIN DLA PARTNERÓW PROGRAMU PARTNERSKIEGO MONETEASY22',
                rel: 'nofollow'
            }
        ]
    },
    {
        label: 'Skąpiec.pl',
        items: [
            {
                label: 'O nas',
                href: '/o-nas',
                title: 'O nas',
                rel: 'nofollow'
            },
            {
                label: 'Centrum prasowe',
                href: '/site/doc/200',
                title: 'Komunikaty prasowe',
                rel: 'nofollow'
            },
            {
                label: 'Kariera',
                href: 'https://www.ringieraxelspringer.pl/kariera/oferty-pracy',
                title: 'Pracuj w Ringier Axel Springer',
                rel: 'nofollow'
            },
            {
                label: 'Kontakt',
                href: '/kontakt',
                title: 'Kontakt',
                rel: 'nofollow'
            },
            {
                label: 'Akt o usługach cyfrowych',
                href: '/akt-uslugi-cyfrowe',
                title: 'Akt o usługach cyfrowych',
                rel: 'nofollow'
            }
        ]
    }
] as {
    label: string;
    items: SiteLink[];
}[];

export const media = [
    {
        label: 'Facebook',
        href: 'https://www.facebook.com/Skapiec',
        title: 'Facebook',
        rel: 'follow noopener',
        icon: 'facebook-filled'
    },
    {
        label: 'Instagram',
        href: 'https://www.instagram.com/skapiec_pl/',
        title: 'Instagram',
        rel: 'follow noopener',
        icon: 'instagram'
    }
] as {
    label: string;
    href: string;
    title: string;
    rel: string;
    icon: string;
}[];
